export const EMPLOYMENT_VALIDATION_RULES = {
  employmentType: {
    isRequiredTrim: {
      value: true,
    },
  },
  startDate: {
    isRequiredTrim: {
      value: true,
    },
  },
  endDate: {
    afterOrEqualOtherDateField: {
      value: {
        field: "startDate",
        customMessageKey: "validation.customMessages.endDate",
      },
    },
  },
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/employments/employmentsValidationRules.js